// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// About Module

// Define the list of client side About Topics

define('About',['require','Utilities'],function (require) {
    'use strict';

    var // Require.js module dependencies
        Utilities = require('Utilities'),

        // Instance variables
        utilities = new Utilities(),
        aboutTopics;


    // Constructor
    function About () {

        // Get app specific parameters
        var appName = utilities.getApplicationName(),
            appVersion = utilities.getApplicationVersion();

        // Define the topics
        aboutTopics = [
            { topic:        'Application',
              description:  '<span>' + appName + ' &copy; 2015-' +
                            new Date().getFullYear(),
              link:         { name: 'Policy Policy',
                              url:  '/apps/' + appName.toLowerCase() +
                              '/privacy_policy.html'
                            }},

            { topic:        'Version',
              description:  appVersion },

            { topic:        'Our Mission',
              description:  appName + ' provides a way for users like ' +
                            'yourself to rate venues in multiple ' +
                            'categories, and to show combined ratings from ' +
                            'all users. You report what you see at local ' +
                            'venues. We assemble your reports and make them ' +
                            'available so that everyone might benefit.  ' +
                            'Spend your valuable time on only the best ' +
                            'venues as rated by ' + appName + '.  It only ' +
                            'works if everyone shares what they see. So, ' +
                            'submit your ratings early and often!' },

            { topic:        'Our History',
              description:  'The idea for ' + appName + ' was first ' +
                            'envisioned circa 2016.  Many existing services ' +
                            'allow consumers to rate venues in one single ' +
                            'dimension.  Given that most all venues are ' +
                            'multi-dimensional, we set out to develop a ' +
                            'general purpose rating application that can be ' +
                            'expanded to include many additional rating ' +
                            'categories as needs evolve.  Thus, ' +
                            appName + ' was born!  Now you can rate a ' +
                            'place on price, service, product, crowds, ' +
                            'ambiance, entertainment... ' +
                            '<p> ' +
                            'We designed ' + appName + ' to expand to ' +
                            'support any rating categories that you find ' +
                            'interesting.  The app allows you to filter ' +
                            'out the noise and show just the ratings of ' +
                            'interest.  The composite score includes all ' +
                            'rating categories, but if you only care about ' +
                            'price and cleanliness, it is easy to filter.  ' +
                            '<p> ' +
                            appName + ' is also a key app for Merchants.  ' +
                            'It is a great vehicle for Merchant Special ' +
                            'Offers and additional services for business ' +
                            'owners.  The Merchant Service is a great way ' +
                            'for venues to better engage with their valued ' +
                            'consumers using multimedia formats.' },

            { topic:        'Our Team',
              description:  'Combining state of the art technology with ' +
                            'fun, brilliant people produces a community ' +
                            'that makes amazing products. ' + appName + ' ' +
                            'is under continuous development by a team ' +
                            'of crackpot Java and JavaScript engineers. ' +
                            'With your help, we will continue to make our ' +
                            'applications better and more useful.  We ' +
                            'welcome your comments and bug reports and ' +
                            'hope you enjoy using our apps.' }
        ];
    }

    // Public Prototype Methods

    // Fetch the client About Topics for display
    About.prototype.getAboutTopics = function () {
        return aboutTopics;
    };

    // Return the constructor
    return About.prototype.constructor;
});

